import React from 'react';

export default function BarrelSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Shadow */}
      <ellipse cx="20" cy="38" rx="11" ry="2" fill="#3E2723" opacity="0.15" />
      {/* Barrel body - slightly bulging */}
      <path d="M12 8C10 8 8 10 7 14C6 18 6 24 7 28C8 32 10 34 12 34L28 34C30 34 32 32 33 28C34 24 34 18 33 14C32 10 30 8 28 8Z" fill="#C49A6C" />
      {/* Inner highlight */}
      <path d="M14 10C12 10 10.5 12 10 15C9.5 18 9.5 24 10 27C10.5 30 12 32 14 32L26 32C28 32 29.5 30 30 27C30.5 24 30.5 18 30 15C29.5 12 28 10 26 10Z" fill="#D4AA7A" />
      {/* Wood plank lines */}
      <path d="M9 14L31 14" stroke="#A67C52" strokeWidth="0.6" opacity="0.4" />
      <path d="M8.5 21L31.5 21" stroke="#A67C52" strokeWidth="0.5" opacity="0.35" />
      <path d="M9 28L31 28" stroke="#A67C52" strokeWidth="0.6" opacity="0.4" />
      {/* Top metal band */}
      <path d="M12 11C10.5 11 9 12 8.5 13L31.5 13C31 12 29.5 11 28 11Z" fill="#90A4AE" />
      <path d="M12 11.5C10.8 11.5 9.5 12.3 9 13L31 13C30.5 12.3 29.2 11.5 28 11.5Z" fill="#B0BEC5" />
      {/* Middle metal band */}
      <ellipse cx="20" cy="21" rx="13.5" ry="1.2" fill="#90A4AE" />
      <ellipse cx="20" cy="20.7" rx="13" ry="0.8" fill="#B0BEC5" />
      {/* Bottom metal band */}
      <path d="M12 31C10.5 31 9 30 8.5 29L31.5 29C31 30 29.5 31 28 31Z" fill="#90A4AE" />
      <path d="M12 30.5C10.8 30.5 9.5 29.7 9 29L31 29C30.5 29.7 29.2 30.5 28 30.5Z" fill="#B0BEC5" />
      {/* Top rim - ellipse for 3D feel */}
      <ellipse cx="20" cy="8" rx="8.5" ry="3" fill="#B8885A" />
      <ellipse cx="20" cy="7.5" rx="7" ry="2.2" fill="#C49A6C" />
      <ellipse cx="20" cy="7.2" rx="5.5" ry="1.6" fill="#1A1210" opacity="0.6" />
      {/* Shine highlight */}
      <path d="M13 14C12 18 12 24 13 28" stroke="white" strokeWidth="1.2" strokeLinecap="round" opacity="0.15" />
    </svg>
  );
}
